__turbopack_context__.v({
  "button": "LikesButton-module-scss-module__A717rq__button",
  "liked": "LikesButton-module-scss-module__A717rq__liked",
  "subItem": "LikesButton-module-scss-module__A717rq__subItem",
});
